import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from '../role.guard';
import { AddadvertizeComponent } from './advertize/addadvertize/addadvertize.component';
import { AdvertizelistComponent } from './advertize/advertizelist/advertizelist.component';
import { AddcategoryComponent } from './category/addcategory/addcategory.component';
import { CategorylstComponent } from './category/categorylst/categorylst.component';
import { PaymentproviderformComponent } from './paymentproviders/paymentproviderform/paymentproviderform.component';
import { PaymentproviderlstComponent } from './paymentproviders/paymentproviderlst/paymentproviderlst.component';
import { PaymentrequestlstComponent } from './paymentrequest/paymentrequestlst/paymentrequestlst.component';
import { AddproductComponent } from './product/addproduct/addproduct.component';
import { ProductlstComponent } from './product/productlst/productlst.component';
import { ProductcardsmanagmentComponent } from './productcardsmanagment/productcardsmanagment.component';
import { AddsubcategoryComponent } from './subcategory/addsubcategory/addsubcategory.component';
import { SubcategorylstComponent } from './subcategory/subcategorylst/subcategorylst.component';
import { ProductcardsinventoryComponent } from './productcardsinventory/productcardsinventory.component';

const routes: Routes = [
  { path: 'categories', component: CategorylstComponent },
  { path: 'addcategory', component: AddcategoryComponent },
  { path: 'editcategory/:id', component: AddcategoryComponent },

  { path: 'subcategory', component: SubcategorylstComponent },
  { path: 'addsubcategory', component: AddsubcategoryComponent },
  { path: 'editsubcategory/:id', component: AddsubcategoryComponent },

  { path: 'products', component: ProductlstComponent },
  { path: 'addproducts', component: AddproductComponent },
  { path: 'editproduct/:id', component: AddproductComponent },

  { path: 'advertize', component: AdvertizelistComponent },
  { path: 'addadvertize', component: AddadvertizeComponent },
  { path: 'editadvertize/:id', component: AddadvertizeComponent },

  {
    path: 'paymentrequests', component: PaymentrequestlstComponent, canActivate: [RoleGuard],
    data: {
      expectedRole: "Admin"
    }
  },

  { path: 'paymentproviders', component: PaymentproviderlstComponent },
  { path: 'addpaymentproviders', component: PaymentproviderformComponent },
  { path: 'editpaymentproviders/:id', component: PaymentproviderformComponent },

  { path: 'productcards', component: ProductcardsmanagmentComponent },
  { path: 'productcardsinventory', component: ProductcardsinventoryComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CardsRoutingModule { }
